<template>
  <div>
    <div class="login-form">
      <div class="login-header">
        <h1 class="login-title" :style="getPrimaryColor">{{ getRegistrationHeading }}</h1>
        <!-- <div class="nav-link text-right" v-if="isSysUserRegistrationEnabled">
        Don't have an account ?
        <router-link to="/signup" class="fw-bold" :style="getPrimaryColor">SignUp!</router-link>
      </div> -->
      </div>
      <div class="divider">
        <span class="line"></span>
        <span class="line"></span>
      </div>
      <el-form
        :model="signup"
        :rules="rules"
        ref="signup"
        class="log-form"
        @keyup.enter.native="submitForm('signup')"
      >
        <el-form-item label="Email Address" prop="email">
          <el-input
            v-model="signup.email"
            placeholder="Ex: johnwesley@abc.com"
            autocomplete="off"
            readonly
          ></el-input>
          <p class="error" v-if="getErrors && getErrors.email">
            {{ getErrors.email }}
          </p>
          <p
            class="error"
            v-if="
              getErrors &&
              getErrors.critical_error &&
              getErrors.critical_error == 'Account with this email is already taken'
            "
          >
            {{ getErrors.critical_error }}
          </p>
        </el-form-item>

        <div class="d-flex">
          <el-form-item label="First Name" prop="first_name" class="mr-1">
            <el-input
              v-model="signup.first_name"
              placeholder="Enter first name"
              :readonly="isDisabled"
            ></el-input>
            <p class="error" v-if="getErrors && getErrors.first_name">
              {{ getErrors.first_name }}
            </p>
          </el-form-item>
          <el-form-item label="Last Name" prop="last_name">
            <el-input
              v-model="signup.last_name"
              placeholder="Enter last name"
              :readonly="isDisabled"
            ></el-input>
            <p class="error" v-if="getErrors && getErrors.last_name">
              {{ getErrors.last_name }}
            </p>
          </el-form-item>
        </div>
        <el-form-item label="Mobile" prop="phone">
          <el-input
            v-model="signup.phone"
            placeholder="989 989 9899"
            autocomplete="off"
            :readonly="isDisabled"
          ></el-input>
          <p class="error" v-if="getErrors && getErrors.phone">
            {{ getErrors.phone }}
          </p>
        </el-form-item>

        <el-form-item label="Choose an Account as" prop="type">
          <br />
          <el-radio-group v-model="signup.accountType" size="mini">
            <el-radio-button label="INDIVIDUAL"></el-radio-button>
            <el-radio-button label="BUSINESS"></el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="signup.accountType == 'BUSINESS'"
          label="Company Name"
          prop="company_name"
        >
          <el-input v-model="signup.company_name" placeholder="Enter company name"></el-input>
          <p class="error" v-if="getErrors && getErrors.company_name">
            {{ getErrors.company_name }}
          </p>
          <p class="error" v-if="errors && errors.company_name">
            {{ errors.company_name }}
          </p>
        </el-form-item>

        <el-form-item prop="terms_and_conditions">
          <el-checkbox name="type" v-model="signup.terms_and_conditions" @change="handleTermsState">
            I agree
            <el-link type="primary" :underline="false" @click="displayTermsAndConditions">
              Terms of Services
            </el-link>
            &
            <el-link type="primary" :underline="false" @click="displayPrivacyPolicy">
              Privacy Policy
            </el-link>
          </el-checkbox>
          <p class="error" v-if="errors.terms_and_conditions">
            You have to agree the terms and privacy condition.
          </p>
        </el-form-item>

        <el-form-item class="mt-1">
          <el-button
            type="primary"
            class="type-2 w-100 fs-6 bg-color"
            @click="submitForm('signup')"
            :loading="submitLoading"
          >
            Activate Account
          </el-button>
          <p
            class="error"
            v-if="
              getErrors &&
              getErrors.critical_error &&
              getErrors.critical_error != 'Account with this email is already taken'
            "
          >
            {{ getErrors.critical_error }}
          </p>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      :visible.sync="terms_and_conditions_dialog"
      :title="isTermsConditionsActive ? 'Terms and Conditions' : 'Privacy Policy'"
      class="terms-conditions-dilalog-main"
      :before-close="resetTermsAndPrivacy"
    >
      <div>
        <div style="padding: 5px" v-if="isTermsConditionsActive">
          <termsAndConditionsTemplate />
        </div>
        <div style="padding: 5px" v-else>
          <privacyAndPolicyTemplate />
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import termsAndConditionsTemplate from '@/components/templates/termsAndConditionsTemplate.vue';
  import privacyAndPolicyTemplate from '@/components/templates/privacyAndPolicyTemplate.vue';
  import CustomizationLayer from '@/mixins/CustomizationLayer';
  export default {
    name: 'SSOSignUp',
    components: {
      termsAndConditionsTemplate,
      privacyAndPolicyTemplate,
    },
    mixins: [CustomizationLayer],
    data() {
      return {
        passwordError: [],
        submitLoading: false,
        passwordType: 'password',
        cpasswordType: 'password',
        isPrivacyPolicyActive: false,
        terms_and_conditions_dialog: false,
        isTermsConditionsActive: false,
        configureLoading: false,
        LoadingText: 'Loading...',
        isDisabled: false,
        companyPattern:
          /^(?!.*[.&!@#()+-/_*]{2})([a-zA-Z0-9.,&!@#()+-/_*]+[^\s])*[a-zA-Z0-9.,&!@#()+-/_*]+$/,

        emailRegistered: true,

        signup: {
          first_name: '',
          last_name: '',
          company_name: '',
          email: '',
          password: '',
          // terms_and_conditions: false,
          phone: '',
          cPassword: '',
          accountType: 'INDIVIDUAL',
        },
        password_rules: [
          {
            message:
              'Must have one Uppercase(A-Z) letter,one lowercase(a-z) letter ,one number(0-9) and one symbol',
            regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/,
          },
        ],
        rules: {
          email: [
            {
              required: true,
              message: 'Email is required',
              trigger: 'blur',
            },
            {
              type: 'email',
              message: 'Invalid Email',
              trigger: 'blur',
            },
          ],
          password: [
            // {
            //   required: true,
            //   message: "Password is required",
            //   trigger: "blur",
            // },
            // { validator: validatePass, trigger: "blur" },
          ],
          cPassword: [
            // {
            //   required: true,
            //   message: "Password is required",
            //   trigger: "blur",
            // },
            // { validator: validatePass2, trigger: "blur" },
          ],
          phone: [
            {
              required: true,
              message: 'Phone is required',
              trigger: 'blur',
            },
          ],
          first_name: [
            {
              required: true,
              message: 'First name is required',
              trigger: 'blur',
            },
          ],
          last_name: [
            {
              required: true,
              message: 'Last name is required',
              trigger: 'blur',
            },
          ],
          company_name: [
            {
              required: true,
              message: 'Company name is required',
              trigger: 'blur',
            },
          ],
        },
        errors: {},
      };
    },
    mounted() {
      this.$store.dispatch('auth/reset');
      this.setSSONewUserDetails();
    },
    computed: {
      ...mapGetters('errors', ['getErrors']),
      ...mapGetters('auth', [
        'getAuthenticationStatus',
        'isSignupCompleted',
        'getAccountNotVerified',
        'getAccountNotVerifiedEmail',
        'getEmailExist',
        'getCompanyInfo',
      ]),
      ...mapGetters('sso', ['getCodeExchangeData', 'getSSONewUserData']),

      termsError() {
        return !this.signup.terms_and_conditions;
      },
      getRegistrationHeading() {
        let heading = '';
        if (this.$route && this.$route.query && this.$route.query.type == 'free-trial') {
          heading = 'Sign up for a free trial!';
        } else if (this.$route && this.$route.query && this.$route.query.type == 'request-demo') {
          heading = 'Request for a demo';
        } else {
          heading = 'Activate Account!';
        }
        return heading;
      },
    },
    created() {
      this.$store.commit('errors/setErrors', null, { root: true });
    },
    methods: {
      setSSONewUserDetails() {
        let ssoUserDetails = { ...this.getSSONewUserData };
        this.signup.cPassword = '123456';
        this.signup.cPassword = '123456';

        this.signup.email = ssoUserDetails.profile.email;
      },

      goToEmployee() {
        this.$router.push({ path: '/employee/signin' });
      },
      submitForm(formName) {
        this.errors = {};

        this.$refs[formName].validate((valid, errors) => {
          if (valid) {
            if (this.passwordError.length) {
              return false;
            } else if (this.emailRegistered && this.errors && this.errors.password) {
              return false;
            } else if (!this.signup.terms_and_conditions) {
              {
                this.errors.terms_and_conditions = true;
                return false;
              }
            } else {
              this.signUp();
            }
          } else {
            console.log(errors);
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      resetTermsAndPrivacy() {
        this.isTermsConditionsActive = false;
        this.terms_and_conditions_dialog = false;
      },
      displayTermsAndConditions() {
        this.isTermsConditionsActive = true;
        this.terms_and_conditions_dialog = true;
      },
      displayPrivacyPolicy() {
        this.terms_and_conditions_dialog = true;
      },
      async signUp() {
        try {
          if (!this.signup.terms_and_conditions) {
            this.$message.error('Please accept terms and conditions!');
          } else {
            this.submitLoading = true;
            let data = {
              first_name: this.signup.first_name,
              last_name: this.signup.last_name,
              email: this.signup.email.toLowerCase(),
              password: this.signup.password,
              terms_and_conditions: this.signup.terms_and_conditions,
              phone: this.signup.phone,
              cPassword: this.signup.cPassword,
              plan_type: this.signup.accountType,
            };
            if (!this.emailRegistered) {
              delete data.password;
              delete data.cPassword;
            }
            if (this.signup.accountType == 'BUSINESS') {
              data['company'] = this.signup.company_name.trim();
            }
            await this.$store.dispatch('auth/companySignup', data);
            if (this.getAccountNotVerified) {
              this.$router.push('/send-verification?email=' + this.signup.email);
            } else if (this.isSignupCompleted) {
              let companyDetails = this.getCompanyInfo.data;
              if (this.getCompanyInfo.message == 'COMPANY_ON_HOLD') {
                this.$notify.success({
                  title: 'Success',
                  message: 'Company Name is already registered with the user and need verification',
                });
                this.$router.push(`/verify?email=${data.email}&company=${companyDetails._id}`);
              } else if (this.getCompanyInfo.message == 'COMPANY_ACTIVE') {
                this.$notify.success({
                  title: 'Success',
                  message: 'Company Name is already registered with the user',
                });
                this.$router.push('/signin');
              } else {
                this.$notify.success({
                  title: 'Success',
                  message: 'Registered Successfully',
                });
                if (companyDetails && companyDetails._id) {
                  this.$router.push(
                    `/sso-verify?email=${data.email}&company=${companyDetails._id}`
                  );
                }
                if (!companyDetails) {
                  this.$router.push(`/verify?email=${data.email}`);
                }
              }
            }
            this.submitLoading = false;
          }
        } catch (err) {
          this.submitLoading = false;
          console.log('signUp', err);
        }
      },
      async checkEmailAlreadyReg() {
        if (this.signup.email) {
          this.configureLoading = true;
          this.LoadingText = 'We are checking the email.... Please wait .....';
          try {
            await this.$store.dispatch('auth/checkUserExist', this.signup.email);
            if (this.getEmailExist) {
              if (this.getEmailExist.status_code === 200 || this.getEmailExist.statusCode === 200) {
                setTimeout(() => {
                  this.LoadingText =
                    'Account already exist with this email. Please continue with existing account Password ';
                }, 2000);

                this.signup.first_name = this.getEmailExist.message.first_name;
                this.signup.last_name = this.getEmailExist.message.last_name;
                this.signup.phone = this.getEmailExist.message.phone;
                this.signup.cPassword = '';
                this.signup.password = '';
                this.emailRegistered = false;
                this.isDisabled = true;

                this.$refs['signup'].validate((valid, errors) => {
                  if (valid) {
                    console.log(valid);
                  } else {
                    console.log(errors);
                  }
                });
                this.$store.commit('errors/setErrors', null, { root: true });
                this.passwordError = [];
                setTimeout(() => {
                  this.configureLoading = false;
                }, 5000);
              } else {
                this.emailRegistered = true;

                setTimeout(() => {
                  this.configureLoading = false;
                  this.LoadingText = 'Loading ....';
                }, 3000);
                this.signup.first_name = '';
                this.signup.last_name = '';
                this.signup.phone = '';
                this.isDisabled = false;
              }
            }
          } catch (err) {
            this.submitLoading = false;
            this.configureLoading = false;
            this.LoadingText = 'Loading ....';
            console.log('checkEmailAlreadyReg', err);
          }
        }
      },

      handleTermsState() {
        this.errors.terms_and_conditions = this.signup.terms_and_conditions ? false : true;
      },
      checkPassword() {
        this.errors.password = '';
        this.passwordError = [];
        if (this.signup.password) {
          this.password_rules.forEach((rule) => {
            if (!rule.regex.test(this.signup.password)) {
              this.passwordError.push(rule.message);
            }
          });
          if (this.signup.password.length && this.signup.cPassword.length) {
            // this.checkConfirmPassword();
            if (this.signup.password != this.signup.cPassword) {
              this.passwordError.push('Password miss match');
            }
          }
        } else {
          {
            this.errors.password = 'Password is required';
          }
        }
      },
      checkConfirmPassword() {
        this.passwordError = [];
        // if (this.passwordError.length && this.signup.cPassword.length) {
        if (this.signup.password != this.signup.cPassword) {
          this.passwordError.push('Password miss match');
        } else {
          this.passwordError = [];
        }
      },
      // checkCompanyName() {
      //   // this.signup.company_name = this.signup.company_name.trim();
      //   if (!this.companyPattern.test(this.signup.company_name)) {
      //     this.errors.company_name = "Invalid Company Name";
      //   } else {
      //     this.errors.company_name = "";
      //   }
      // },
    },
  };
</script>
<style lang="scss">
  .swal2-icon {
    .swal2-info {
      border-color: #f754a2 !important;
      color: #f754a2 !important;
    }
  }

  .swal2-styled {
    .swal2-confirm {
      background-color: #f754a2 !important;
    }
  }

  .has-error {
    border-color: red;
  }

  a {
    text-decoration: none !important;
    color: #196392 !important;
  }

  a:hover {
    text-decoration: underline !important;
    /* Optional: underline on hover */
    color: #196392 !important;
  }

  .divider {
    display: flex;
    align-items: center;
    width: 100%;
    text-align: center;
    /* margin: 0 20px; */
  }

  .line {
    flex: 1;
    border-top: 1px solid #ddd;
    /* light gray line */
  }

  .password-input-wrapper {
    position: relative;
  }

  .password-toggle {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #409eff;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    user-select: none;
  }

  .login-form {
    border: 1px solid #cfcfcf;
    border-radius: 2em;
    width: 100%;
    max-width: 550px;
    padding: 2rem;
    /* border-radius: 8px; */
    background: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
  }

  .login-form h2 {
    margin-bottom: 1.5rem;
    color: #333;
    text-align: center;
  }

  .login-form input {
    width: 100%;
    padding: 0.75rem;
    margin-bottom: 1rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
  }

  /* FULL RESPONSIVE FOR MOBILE & TABLET */
  @media (max-width: 1024px) {
    .login-form {
      border: 1px solid #cfcfcf;
      border-radius: 2em;
      // max-width: 100%;
      padding: 1.5rem;
      margin: 0 auto;
      box-shadow: none;
      /* border-radius: 0; */
    }

    .login-form h2 {
      font-size: 1.5rem;
    }

    .password-toggle {
      right: 10px;
      font-size: 12px;
    }
  }

  .el-form-item {
    margin-bottom: 8px !important;
  }

  .name-fields {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  @media (min-width: 768px) {
    .name-fields {
      flex-direction: row;
    }

    .name-fields .el-form-item {
      flex: 1;
    }

    .name-fields .el-form-item:first-child {
      margin-right: 10px;
    }
  }

  .terms-wrap {
    display: inline-block;
    white-space: normal;
    word-break: break-word;
    max-width: 100%;
  }

  .d-flex {
    display: flex;
  }

  .justify-between {
    justify-content: space-between;
  }

  .align-center {
    align-items: center;
  }

  .flex-wrap {
    flex-wrap: wrap;
  }

  .mb-3 {
    margin-bottom: 1rem;
  }

  .m-0 {
    margin: 0;
  }

  .register-heading {
    font-size: 1.25rem;
    font-weight: 600;
    color: #196392;
    padding-bottom: 0.5rem;
    margin: 0;
    display: inline-block;
  }
</style>
